module.exports = __webpack_public_path__ + "static/media/SP_S_Timeless_Sforza_Sand.e199021b.png";